import{userDidLogin$,userDataReceived$}from'@shopgate/engage/user';/**
 * Gets triggered if login was successful and we received the user data.
 */export var loginSuccess$=userDidLogin$.switchMap(function(){return userDataReceived$.first();});